import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  host: {
    'class': 'flex flex-col sm:flex-row items-center justify-between py-2.5 sm:py-0 min-h-10 sm:h-10 bg-white dark:bg-slate-900 border-t border-slate-200/80 dark:border-slate-800 px-4 md:px-6 text-[11px] text-slate-400 dark:text-slate-500 shrink-0 w-full gap-1.5 sm:gap-0'
  }
})
export class FooterComponent {}
